/* eslint-disable no-console */
import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardAvatar from "../../components/Card/CardAvatar.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardFooter from "../../components/Card/CardFooter.jsx";
import { spinnerService } from "@chevtek/react-spinners";
import imgPlaceholder from "../../assets/img/person-placeholder.jpg";
import Icon from "@material-ui/core/Icon";
import Avatar from "@material-ui/core/Avatar";
import NumberFormat from "react-number-format";
import * as actionTypes from "../../redux/actions";
import awsConfigSettings from "../../aws-exports";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import _ from "lodash";
import { flowRight } from "lodash";

import { toast } from "react-toastify";
import Input from "@material-ui/core/Input";
import { Link } from "react-router-dom";

import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { getCustomerTeam, updateCustomerTeam } from "../../graphql/mutations";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};
const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class TeamDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      empType: null,
      empName: "",
      phoneNo: "",
      email: "",
      oldPassword: "",
      _oldPassword: {
        value: "",
        isValid: true,
        err: ""
      },
      password: "",
      _password: {
        value: "",
        isValid: true,
        err: ""
      },
      cPassword: "",
      _cPassword: {
        value: "",
        isValid: true,
        err: ""
      },
      accountStatus: null,
      verifyPhone: false,
      verifyEmail: false,
      emailErr: "",
      phoneErr: "",
      notes: "",
      username: null,
      passwordDialog: false,
      registrationDate: "",
      id: "",
      userId: "",
      isEdit: false,
      errors: {
        cognito: false,
        blankfield: false,
        passwordmatch: false
      },
      emailValidate: true,
      emailFeedback: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getUserDetails = async id => {
    const self = this;
    let userPoolId = awsConfigSettings.aws_user_pools_id;
    let credentials = await Auth.currentCredentials();
    let client = await Promise.resolve(
      new CognitoIdentityServiceProvider({
        apiVersion: "2016-04-18",
        credentials: Auth.essentialCredentials(credentials),
        region: "us-east-2"
      })
    );
    let params = {
      UserPoolId: userPoolId /* required */,
      Username: id /* required */
    };
    let userObj = {};
    await client.adminGetUser(params, function(err, data) {
      if (data !== null && err === null) {
        data.UserAttributes.map(dt => {
          if (dt.Name === "phone_number_verified") {
            userObj.phoneVerified = dt.Value;
          }
          if (dt.Name === "email_verified") {
            userObj.emailVerified = dt.Value;
          }
        });
        self.setState(
          {
            verifyEmail:
              userObj.emailVerified && userObj.emailVerified === "true"
                ? true
                : false,
            verifyPhone:
              userObj.phoneVerified && userObj.phoneVerified === "true"
                ? true
                : false
          },
          () => {
            spinnerService.hide("mySpinner");
          }
        );
      } else {
        toast.error("Some User Details Not Found");
      }
    });
  };

  async componentDidMount() {
    spinnerService.show("mySpinner");
    if (this.props.match.params.id === undefined) {
      return;
    }
    let memId = this.props.match.params.id;
    const { client, user, customerTeam } = this.props;
    let data = {};
    let isFetched = false;
    if (
      customerTeam !== undefined ||
      customerTeam !== null ||
      customerTeam !== ""
    ) {
      if (customerTeam.length > 0) {
        data = customerTeam.filter(item => {
          return item.id === memId;
        });
      }
    }
    if (data === null || data === "") {
      const getCustomerTeam = await client.query({
        query: gql(getCustomerTeam),
        fetchPolicy: `network-only`,
        variables: {
          id: memId
        }
      });
      data = getCustomerTeam.data.getCustomerTeam;
      isFetched = true;
    }
    this.setState(data[0]);
    await this.getUserDetails(memId).catch(err => {
      toast.err(err.message);
      spinnerService.hide("mySpinner");
    });
  }

  async handleSubmit() {
    spinnerService.show("mySpinner");
    let isError = false;
    const {
      empType,
      empName,
      phoneNo,
      email,
      accountStatus,
      notes,
      username,
      id,
      verifyEmail,
      verifyPhone
    } = this.state;

    let customerId = this.props.user.username;
    const { addTeamMember } = this.props; //.addTeamMember

    if (["", null, undefined].includes(phoneNo) || phoneNo.length < 10) {
      this.setState({
        phoneErr: "Valid Phone Number is Required"
      });
      //   setForceSubmit(true);
      spinnerService.hide("mySpinner");
      return;
    } else
      try {
        let input = {
          id,
          // customerTeamCustomerId: customerId,
          empType: empType
        };
        if (!_.isEmpty(empName)) input.empName = empName;
        if (!_.isEmpty(phoneNo)) input.phoneNo = phoneNo;
        if (!_.isEmpty(email) && re.test(email.toLowerCase()))
          input.email = email;
        if (!_.isEmpty(email) && re.test(email.toLowerCase()))
          input.username = email;
        input.accountStatus = "ACTIVE";
        if (!_.isEmpty(notes)) input.notes = notes;

        var result = API.graphql(
          graphqlOperation(updateCustomerTeam, { input })
        );
        let userPoolId = awsConfigSettings.aws_user_pools_id;
        let credentials = await Auth.currentCredentials();
        let client = await Promise.resolve(
          new CognitoIdentityServiceProvider({
            apiVersion: "2016-04-18",
            credentials: Auth.essentialCredentials(credentials),
            region: "us-east-2"
          })
        );
        let memId = this.props.match.params.id;
        let params = {
          UserAttributes: [
            {
              Name: "email" /* required */,
              Value:
                ["", null, undefined].includes(email) ||
                !re.test(email.toLowerCase())
                  ? ""
                  : email
            },
            {
              Name: "phone_number" /* required */,
              Value: ["", null, undefined].includes(phoneNo) ? "" : phoneNo
            },
            {
              Name: "phone_number_verified" /* required */,
              Value: verifyPhone || verifyPhone === "true" ? "true" : "false"
            },
            {
              Name: "email_verified" /* required */,
              Value: verifyEmail || verifyEmail === "true" ? "true" : "false"
            }
          ],
          UserPoolId: userPoolId /* required */,
          Username: memId /* required */
        };
        await client.adminUpdateUserAttributes(params, function(err, data) {
          if (data !== null && err === null) {
            toast.success("User Updated!");
          } else {
            toast.error("An Error Occurred. Try Again!");
          }
        });
        //update redux store with updated
        this.props.updateTeam(input);
        this.props.history.goBack();
        spinnerService.hide("mySpinner");
        // toast.success("User Updated!");

        // "User Created", result;
      } catch (err) {
        spinnerService.hide("mySpinner");
      }
  }

  changePassword = e => {
    const { id, value } = e.target;
    this.setState({
      [id]: {
        value,
        isValid: true,
        err: ""
      }
    });
  };

  setPassword = async e => {
    e.preventDefault();
    let { password, cPassword, _password, _cPassword } = this.state;
    if (["", null, undefined].includes(_password.value) || !_password.isValid) {
      this.submitCheck("_password", _password.value);
      //   document.getElementById("_password").focus();
    } else if (
      ["", null, undefined].includes(_cPassword.value) ||
      !_cPassword.isValid
    ) {
      this.submitCheck("_cPassword", _cPassword.value);
      //   document.getElementById("_cPassword").focus();
    } else {
      try {
        password = _password.value;
        cPassword = _cPassword.value;
        // oldPassword = _oldPassword.value;
        this.setState({
          password: _password.value,
          cPassword: _cPassword.value
          // oldPassword: _oldPassword.value
        });
        spinnerService.show("mySpinner");
        let userPoolId = awsConfigSettings.aws_user_pools_id;
        let credentials = await Auth.currentCredentials();
        let client = await Promise.resolve(
          new CognitoIdentityServiceProvider({
            apiVersion: "2016-04-18",
            credentials: Auth.essentialCredentials(credentials),
            region: "us-east-2"
          })
        );
        var params = {
          UserPoolId: userPoolId /* required */,
          Password: password,
          Username: this.state.id /* required */,
          Permanent: true
        };
        await client.adminSetUserPassword(params, function(err, data) {
          if (data !== null && err === null) {
            spinnerService.hide("mySpinner");
            toast.success("Password Changed");
          } else {
            spinnerService.hide("mySpinner");
            toast.error("Password Not Changed");
          }
        });
        this.setState({
          passwordDialog: false,
          _password: {
            value: "",
            isValid: true,
            err: ""
          },
          _cPassword: {
            value: "",
            isValid: true,
            err: ""
          }
        });
      } catch (err) {
        spinnerService.hide("mySpinner");
        // this.props.storeUser("notFound");
        toast.error(err.message);
      }
    }
  };

  submitCheck = (id, value) => {
    if (["", null, undefined].includes(value) || value.length <= 0) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else {
      if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be 6 Characters Atleast"
          }
        });
      } else if (id === "_cPassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Didn't Match"
          }
        });
      }
    }
  };

  checkPassword = e => {
    const { id, value } = e.target;
    if (["", null, undefined].includes(value) || value.length <= 0) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else {
      if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be 6 Characters Atleast"
          }
        });
      } else if (id === "_cPassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Didn't Match"
          }
        });
      }
    }
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  PasswordDialog = () => {
    return (
      <Dialog
        open={this.state.passwordDialog}
        onClose={() =>
          this.setState({
            passwordDialog: false
          })
        }
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
        <DialogContent>
          <TextField
            value={this.state._password.value}
            onChange={this.changePassword}
            onBlur={this.checkPassword}
            margin="dense"
            id="_password"
            label="New Password"
            error={!this.state._password.isValid}
            helperText={this.state._password.err}
            type="password"
          />
          <TextField
            value={this.state._cPassword.value}
            onChange={this.changePassword}
            onBlur={this.checkPassword}
            margin="dense"
            id="_cPassword"
            label="Confirm New Password"
            error={!this.state._cPassword.isValid}
            helperText={this.state._cPassword.err}
            type="password"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClose={() =>
              this.setState({
                passwordDialog: false
              })
            }
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={this.setPassword} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <this.PasswordDialog />
        <GridContainer>
          {" "}
          <GridItem xs={12} sm={12} md={2}></GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                  Edit {this.props.match.params.type} Account
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 5 }}
                      id="id"
                      disabled="true"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Username"
                      type="text"
                      value={this.state.id}
                      required
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button
                      color="info"
                      onClick={() =>
                        this.setState({
                          passwordDialog: true
                        })
                      }
                    >
                      Change Password
                    </Button>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 15 }}
                      id="empName"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Employee Name"
                      type="text"
                      value={this.state.empName}
                      required
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 15 }}
                      id="email"
                      onChange={e => {
                        this.onInputChange(e);
                        this.setState({ verifyEmail: false });
                      }}
                      placeholder="Email"
                      type="text"
                      value={this.state.email}
                      required
                    />
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={
                              this.state.email &&
                              !re.test(this.state.email.toLowerCase())
                            }
                            checked={this.state.verifyEmail}
                            onChange={e => {
                              if (re.test(this.state.email.toLowerCase())) {
                                this.setState({
                                  verifyEmail: e.target.checked
                                });
                              } else {
                                this.setState({
                                  verifyEmail: false
                                });
                              }
                            }}
                            value={this.state.verifyEmail}
                          />
                        }
                        label="Mark as Verified"
                      />
                    </FormGroup>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      autoFocus
                      required={true}
                      margin="dense"
                      id="phoneNo"
                      label="Phone Number"
                      placeholder="+1(541) 754-3010"
                      type="tel"
                      error={this.state.phoneErr}
                      helperText={this.state.phoneErr}
                      value={this.state.phoneNo}
                      onChange={e => {
                        this.onInputChange(e);
                        this.setState({ verifyPhone: false, phoneErr: "" });
                      }}
                    />
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={this.state.phoneNo.length < 9}
                            checked={this.state.verifyPhone}
                            onChange={e => {
                              if (this.state.phoneNo.length >= 10) {
                                this.setState({
                                  verifyPhone: e.target.checked
                                });
                              } else {
                                this.setState({
                                  verifyPhone: false
                                });
                              }
                            }}
                            value={this.state.verifyPhone}
                          />
                        }
                        label="Mark as Verified"
                      />
                    </FormGroup>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 25 }}
                      id="notes"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Notes"
                      type="text"
                      value={this.state.notes}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                {" "}
                <div style={{ float: "right", marginTop: 20 }}>
                  <Button
                    color="secondary"
                    onClick={() =>
                      this.props.history.push(
                        "/profile/list/" + this.props.match.params.type
                      )
                    }
                  >
                    Back
                  </Button>
                  <Button color="primary" onClick={() => this.handleSubmit()}>
                    Update User
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={2}></GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    profile: state.config.profile,
    customerTeam: state.config.customerTeam
  };
};
const mapDispatchToProps = dispatch => {
  return {
    addTeamMember: data => dispatch(actionTypes.addTeamMember(data)),
    updateTeam: data => dispatch(actionTypes.updateTeam(data))
  };
};
export default TeamDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(TeamDetails)));



// WEBPACK FOOTER //
// ./src/customers/profile/TeamDetails.jsx